/* eslint-disable complexity */
import { createAutoDeleteFolder, isFileForOpenInEditor, openEditor } from 'reactApp/appHelpers/appHelpers';
import { platform } from 'reactApp/appHelpers/configHelpers';
import { toolbarActions } from 'reactApp/appHelpers/toolbarActions';
import { EAllDocumentsType } from 'reactApp/modules/allDocuments/allDocuments.types';
import { attachesOpenViewer } from 'reactApp/modules/attaches/attaches.actions';
import { isFolder, isPdf } from 'reactApp/modules/file/utils';
import { changeHomeHistory, setDomainFoldersFilterActive } from 'reactApp/modules/home/home.actions';
import { historyPush } from 'reactApp/modules/router/router.module';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { trashbinRestoreRequest } from 'reactApp/modules/trashbin/trashbin.module';
import { openUserQuotaItemView } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.actions';
import { openViewer } from 'reactApp/modules/viewer/viewer.module';
import { createCreateNewMenu } from 'reactApp/ui/ContextMenu/createContextMenuList';
import { renderContextMenu } from 'reactApp/ui/ContextMenu/createContextMenuToolkit';
import { logHandler } from 'reactApp/ui/Datalist/DataList.helpers';
import { DropdownTheme } from 'reactApp/ui/DropdownList/DropdownList';
import { sendDatalistGa } from 'reactApp/utils/datalistGa';
import { sendDwh, sendGa } from 'reactApp/utils/ga';
import { getEncodePath, getHomeFolderPath } from 'reactApp/utils/urlHelper';

const getItemId = (item) => {
    const { isPublic, isAlbums } = getStorage(item.storage);

    if (isAlbums) {
        return item.id;
    }

    if (isPublic) {
        return item.weblink;
    }

    return item.home || item.id;
};

export const onItemClick = ({ id, item, goTo, dispatch, storage, viewMode, attachType, attachFolderId, currentAllDocsType }) => {
    const isFile = !isFolder(item);
    const {
        isSharedIncoming,
        isTrashBin,
        isHome,
        isSearch,
        isSharedLinks,
        isSharedAutodelete,
        isFavorites,
        isQuotaCleaner,
        isAttaches,
        isAllDocuments,
    } = getStorage(item.storage);
    const reloadPageToFolderHome = (isSearch || isSharedLinks || isSharedIncoming) && item.isFolder;
    const openFolderHome = (isFavorites || isSharedAutodelete) && item.isFolder;
    const isHomeFolder = isHome && !isFile;
    const isOpenViewer = !item.isFolder;
    const inviteToken = isSharedIncoming && item.inviteToken;

    sendDatalistGa('open', `${item.isFolder ? 'folder' : 'file'}${viewMode}`);

    if (isQuotaCleaner) {
        dispatch(openUserQuotaItemView({ id: item.id }));
        return;
    }

    if (inviteToken) {
        toolbarActions.mount();
    } else if (isTrashBin) {
        dispatch(
            trashbinRestoreRequest({
                ids: [item.id],
                from: 'double-click',
            })
        );
    } else if (openFolderHome) {
        dispatch(historyPush({ id: getHomeFolderPath(item.home) }));
    } else if (reloadPageToFolderHome) {
        // TODO: routing
        location.href = getHomeFolderPath(getEncodePath(item.home));
    } else if (isAllDocuments) {
        sendDwh({
            eventCategory: 'docs',
            action: 'open',
            dwhData: {
                source: currentAllDocsType,
                type_content: currentAllDocsType,
                platform,
                extension: item.ext,
                size_file: item.size,
            },
        });
        if (isPdf(item)) {
            window.open(`${window.location.origin}/home/${item.home}`);
        } else {
            openEditor(item);
        }
    } else if (isFileForOpenInEditor(item)) {
        openEditor(item);
    } else if (isHomeFolder) {
        dispatch(changeHomeHistory({ id }));
        dispatch(setDomainFoldersFilterActive(false));
    } else if (isOpenViewer) {
        const data = {
            itemId: getItemId(item),
            itemStorage: storage || null,
            gaSuffix: '',
            itemIds: [],
        };
        sendGa('datalist', 'open-viewer', viewMode);

        if (isAttaches) {
            dispatch(attachesOpenViewer({ id: item.id, attachType, folderId: attachFolderId }));
        } else {
            dispatch(openViewer(data));
        }
    } else {
        goTo({ id, item });
    }
};

export const onClickCreateNew = (
    e,
    { gaSuffix, storage, currentAllDocsType }: { gaSuffix: string; storage: EStorageType; currentAllDocsType?: EAllDocumentsType }
) => {
    const { isSharedLinks, isSharedAutodelete, isAllDocuments } = getStorage(storage);

    e.preventDefault();
    e.stopPropagation();

    if (isSharedAutodelete) {
        createAutoDeleteFolder();
        return;
    }

    if (isSharedLinks) {
        logHandler({
            radarName: 'createnew_shared_click',
        });
        toolbarActions.create('folder', 'datalist', true, 'shared', true);

        return;
    }

    if (isAllDocuments) {
        logHandler({
            radarName: 'createnew_docs',
        });
        toolbarActions.create(currentAllDocsType === EAllDocumentsType.spreadsheet ? 'xlsx' : 'docx', 'datalist', true, 'docs');

        return;
    }

    logHandler({
        radarName: 'createnew_click',
    });
    renderContextMenu({
        posX: e.pageX,
        posY: e.pageY,
        menuItems: createCreateNewMenu({ createFrom: 'datalist' }),
        theme: DropdownTheme.medium,
        gaSuffix: `ctx_create${gaSuffix ? `_${gaSuffix}` : ''}`,
        storage,
    });
};
